<div [formGroup]="phoneForm">
  <div>
    <!-- <h1 class="label">{{ 'FORM.LABELS.PHONE_NUMBER' | translate}}*</h1> -->
    <div class="grid-gap">
      <div class="input-form-box">
        <div class="input-box">
          <button
            class="flag-button"
            *ngIf="selectedCode"
            (click)="openCountriesModal(true)"
          >
            <img 
              *ngIf="getSelectedCountry()?.flag" 
              [src]="getSelectedCountry()?.flag" 
              [alt]="getSelectedCountry()?.name" 
              class="country-flag" 
            />
            <span>{{ selectedCode }}</span>
          </button>
        </div>
      </div>
      <div class="input-form-box">
        <div class="input-box">
          <input
            formControlName="phone"
            [ngStyle]="{'border': (submitted && phoneControl?.invalid) ? '1px rgba(152, 26, 48, 1) solid' : '1px white solid'}"
            type="tel"
            autocomplete="off"
            placeholder="{{ 'FORM.PLACEHOLDER.PHONE_NUMBER' | translate}}"
            (input)="onPhoneInput($event)"
          />
        </div>
      </div>
    </div>
    <div
      *ngIf="submitted && phoneControl?.hasError('required')"
      class="error-message"
    >
      {{ 'FORM.ERROR.REQUIRED' | translate }}
    </div>
    <div
      *ngIf="submitted && phoneControl?.hasError('phoneNumberInvalid')"
      class="error-message"
    >
      {{ 'FORM.ERROR.PHONE_NUMBER_INVALID' | translate }}
    </div>
    <div
      *ngIf="submitted && phoneControl?.hasError('phoneNumberFormat')"
      class="error-message"
    >
      {{ 'FORM.ERROR.PHONE_NUMBER_FORMAT' | translate }}
    </div>
  </div>

  <!-- Modal de sélection du pays -->
  <ion-modal
    [initialBreakpoint]="1"
    [breakpoints]="[0, 1]"
    (ionModalDidDismiss)="openCountriesModal(false)"
    [isOpen]="countriesModal"
  >
    <ng-template class="counties-modal-template">
      <div class="modal-wrapper">
        <div class="search-country-block">
          <div class="btn-return-b">
            <button
              class="return-btn"
              (click)="openCountriesModal(false)"
            ></button>
            <div class="search-position-wrapper">
              <input
                type="text"
                placeholder="Chercher un pays"
                (input)="onSearchCountry($event)"
                [value]="searchTerm"
              />
              <button 
                type="button" 
                class="clear-filter-btn"
                (click)="clearFilter()"
                *ngIf="searchTerm"
              >
                ✕
              </button>
            </div>
          </div>
        </div>
        <div
          class="countrie-info"
          *ngFor="let country of filteredCountries"
          (click)="selectCountry(country)"
          class="radio"
        >
          <input
            [id]="country.code"
            name="country"
            [value]="country.dialCode"
            type="radio"
          />
          <label [for]="country.code" class="radio-label">
            <img [src]="country.flag" [alt]="country.name" class="country-flag" />
            <span>{{ country.name }} ({{ country.dialCode }})</span>
          </label>
        </div>
      </div>
    </ng-template>
  </ion-modal>
</div>
